function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, RefObject, CSSProperties, useState, useCallback } from 'react';
import cn from 'classnames';
import { IWithControlProps, withControl } from '../withControl/withControl';
import { ISearchActionButtonNamedProps, ISearchActionButtonProps, SearchActionButton } from './ActionButton/Search-ActionButton';
import { ISearchControlProps, SearchControl } from './Control/Search-Control';
import { ISearchIconProps, SearchIcon } from './Icon/Search-Icon';
require("./Search.css");
var styles = {
  "Root": "Search-module-Root_1Dk",
  "Label": "Search-module-Label_1K1",
  "Control": "Search-module-Control_1Ei",
  "pressed": "Search-module-pressed_JrS"
};
const SearchBase = ({
  showIcon,
  showCrossButton = false,
  onCrossButtonClick,
  showMicrophoneButton,
  onMicrophoneButtonClick,
  showCameraButton,
  onCameraButtonClick,
  onMouseEnter,
  onMouseLeave,
  pressed: pressedProp,
  focused,
  innerRef,
  className,
  style = {},
  ...props
}) => {
  const [pressedState, setPressedState] = useState(false);
  const setStatePressed = useCallback(() => setPressedState(true), [setPressedState]);
  const setStateUnpressed = useCallback(() => setPressedState(false), [setPressedState]);
  return /*#__PURE__*/React.createElement("span", {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    ref: innerRef,
    className: cn(styles.Root, {
      [styles.focused]: focused,
      [styles.pressed]: pressedProp || pressedState
    }, className),
    style: style
  }, /*#__PURE__*/React.createElement("label", {
    onPointerDown: setStatePressed,
    onPointerUp: setStateUnpressed,
    onPointerLeave: setStateUnpressed,
    className: styles.Label
  }, /*#__PURE__*/React.createElement(SearchIcon, {
    showIcon: showIcon
  }), /*#__PURE__*/React.createElement(SearchControl, _extends({
    className: styles.Control
  }, props))), /*#__PURE__*/React.createElement(SearchActionButton, {
    icon: "close",
    isVisible: showCrossButton,
    onClick: onCrossButtonClick
  }), /*#__PURE__*/React.createElement(SearchActionButton, {
    icon: "microphone",
    isVisible: showMicrophoneButton,
    onClick: onMicrophoneButtonClick
  }), /*#__PURE__*/React.createElement(SearchActionButton, {
    icon: "camera",
    isVisible: showCameraButton,
    onClick: onCameraButtonClick
  }));
};
export const Search = withControl(SearchBase);
if (process.env.NODE_ENV !== 'production') {
  Search.displayName = 'Search';
}